<template>
  <v-card
    v-if="ofertasadd"
    class="mb-10"
  >
    <template>
      <!-- <v-subheader>Datos Personales</v-subheader> -->
      <v-container fluid>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <input
            v-model="editedItem.id"
            type="hidden"
          >
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="2"
            >
              <v-menu
                ref="menuFn"
                v-model="menuFn"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <label>Fecha de Registro OFERTAS</label>
                  <v-text-field
                    v-model="editedItem.fecha"
                    label="Fecha de Registros"
                    hint="DD/MM/YYYY"
                    solo
                    persistent-hint
                    prepend-icon="mdi-calendar-month"
                    v-bind="attrs"
                    :rules="[v => !!v || 'Fecha es requerida']"
                    @blur="dateFn = parseDate(editedItem.fecha)"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="dateFn"
                  locale="es"
                  show-current="false"
                  @input="menuFn = false"
                />
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="2"
            >
              <label>Estado</label>
              <v-select
                v-model="editedItem.estado"
                label="Estado"
                :items="['PENDIENTE', 'EN CURSO', 'FINALIZADA']"
                solo
                :rules="[v => !!v || 'Campo requerido']"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <label>Ofertante</label>
              <v-overflow-btn
                v-model="editedItem.ofertante"
                label="Ofertante"
                attach
                solo
                editable
                :items="
                  ofertantes.map(function(item) {
                    return {
                      text: item.nombre_apellido,
                      value: item.id
                    };
                  })
                "
                :menu-props="{maxHeight:200 }"
                clearable
                required
                :rules="[v => !!v || 'Campo requerido']"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="2"
            >
              <label>Donativo</label>
              <v-text-field
                v-model="editedItem.donativo"
                solo
                label="Donativo"
                suffix="€"
                :rules="donativoRule"
                hint="Formato de ejemplo: 1.345,30"
                persistent-hint
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="4"
            >
              <label>Oferta</label>
              <v-textarea
                v-model="editedItem.oferta"
                name="input-7-1"
                label="Oferta"
                solo
                :rules="[v => !!v || 'Campo requerido']"
                auto-grow
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="4"
            >
              <label>Condiciones</label>
              <v-textarea
                v-model="editedItem.condiciones"
                name="input-7-1"
                label="Condiciones"
                solo
                :rules="[v => !!v || 'Campo requerido']"
                auto-grow
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="4"
            >
              <label>Observaciones</label>
              <v-textarea
                v-model="editedItem.observaciones"
                solo
                label="Observaciones"
                auto-grow
              />
            </v-col>
          </v-row>
          <!-- ───────── Sección de Entrevistas ───────── -->
          <v-divider class="my-4" />
          <div class="text-subtitle-1 font-weight-bold mb-3">
            Registrar Entrevista
          </div>
          <v-row align="center">
            <v-col
              cols="12"
              sm="12"
              md="5"
            >
              <label>Candidata</label>
              <v-autocomplete
                v-model="editedItem.candidata"
                label="Candidata"
                :items="candidatasList"
                item-text="nombre_apellido"
                item-value="id"
                :search-input.sync="searchCandidata"
                :loading="loadingCandidata"
                no-data-text="No se encontraron coincidencias"
                hide-no-data
                clearable
                solo
                required
                :rules="[v => !!v || 'Campo requerido']"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
            >
              <label>Fecha</label>
              <v-menu
                ref="menuEntrevista"
                v-model="menuEntrevista"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="entrevistaFecha"
                    label="Fecha"
                    hint="DD/MM/YYYY"
                    solo
                    persistent-hint
                    prepend-icon="mdi-calendar-month"
                    v-bind="attrs"
                    @blur="entrevistaDatePicker = parseDate(entrevistaFecha)"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="entrevistaDatePicker"
                  locale="es"
                  show-current="false"
                  @input="menuEntrevista = false"
                />
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="2"
            >
              <label>Contratada</label>
              <v-radio-group
                v-model="entrevistaContratada"
                row
                class="mt-1"
              >
                <v-radio
                  label="SI"
                  :value="1"
                />
                <v-radio
                  label="NO"
                  :value="0"
                />
              </v-radio-group>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="2"
              class="d-flex align-end"
            >
              <v-btn
                color="success"
                :loading="loadingEntrevistas"
                :disabled="!editedItem.id || !entrevistaFecha || entrevistaContratada === null"
                @click="agregarEntrevista"
              >
                <v-icon left>
                  mdi-plus
                </v-icon>
                Agregar
              </v-btn>
            </v-col>
          </v-row>

          <!-- Tabla de entrevistas registradas -->
          <v-data-table
            v-if="entrevistas.length > 0"
            :headers="entrevistaHeaders"
            :items="entrevistas"
            :loading="loadingEntrevistas"
            class="elevation-1 mt-4"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.confirmada="{ item }">
              <v-chip
                :color="item.confirmada ? 'success' : 'default'"
                small
              >
                {{ item.confirmada ? 'SI' : 'NO' }}
              </v-chip>
            </template>
            <template v-slot:item.acciones="{ item }">
              <v-icon
                small
                color="error"
                @click="eliminarEntrevista(item)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
          <div
            v-else
            class="text-caption grey--text mt-2"
          >
            No hay entrevistas registradas para esta oferta.
          </div>
          <v-card-actions>
            <v-row>
              <v-spacer />
              <v-btn
                color="#F6F6F6"
                style="color:black;"
                @click="volver"
              >
                {{ $t("close") }}
              </v-btn>
              <v-btn
                class="mr-4"
                color="primary"
                :loading="loading"
                @click="submit"
              >
                {{ $t("save") }}
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-form>
      </v-container>
    </template>
  </v-card>
</template>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'
  export default {
    name: 'AddOfertas',
    props: {
      editedItem: {
        type: Object,
        required: true,
      },
      editedIndex: {
        type: Number,
        default: 0,
      },
    },
    data: vm => {
      return {
        tab: null,
        valid: true,
        dateFn: new Date().toISOString().substr(0, 10),
        menuFn: false,
        search: '',
        reset: false,
        emailRules: [
          v => !!v || 'EL correo electrónico es requerido',
          v => /.+@.+\..+/.test(v) || 'Ingresa un correo valido',
        ],
        edad: [
          v => {
            if (!isNaN(parseFloat(v)) && v >= 0) return true
            return 'Ingresa un número'
          },
        ],
        donativoRule: [
          // No es obligatorio, pero si se ingresa un valor se debe cumplir la regla
          (v) => (!v || /^(?:(?:\d{1,3}(\.\d{3})*(,\d{2})?)|\d+,\d{2})$/.test(v)) || 'Si va a agregar decimales, deben ser siempre dos. Formato de ejemplo: 1.345,30',
        ],
        editedItem: {
          id: 0,
          fecha: '',
          oferta: '',
          condiciones: '',
          candidata: '',
          ofertante: '',
          donativo: '',
          observaciones: '',
          estado: 'PENDIENTE',
        },
        candidatasList: [],
        searchCandidata: null,
        loadingCandidata: false,
        // Entrevista
        menuEntrevista: false,
        entrevistaFecha: '',
        entrevistaDatePicker: new Date().toISOString().substr(0, 10),
        entrevistaContratada: 0,
        entrevistaHeaders: [
          { text: 'Candidata', value: 'usuaria_nombre', sortable: false },
          { text: 'Fecha', value: 'fecha', sortable: false },
          { text: 'Contratada', value: 'confirmada', sortable: false },
          { text: 'Acciones', value: 'acciones', sortable: false },
        ],
      }
    },
    computed: {
      ofertasadd: {
        get () {
          return this.$store.state.ofertas.ofertasadd
        },
      },
      ofertantes: {
        get () {
          return this.$store.state.ofertantes.ofertantes
        },
      },
      usuarias () {
        return this.$store.state.registros.registros.items || []
      },
      loading: {
        get () {
          return this.$store.state.ofertas.loading
        },
      },
      loadingEntrevistas: {
        get () {
          return this.$store.state.registros.loadingEntrevistas
        },
      },
      entrevistas: {
        get () {
          return this.$store.state.registros.entrevistas
        },
      },
      ...mapState('registros', ['registros']),
    },
    watch: {
      dateFn (val) {
        this.editedItem.fecha = this.formatDate(this.dateFn)
      },
      entrevistaDatePicker (val) {
        this.entrevistaFecha = this.formatDate(val)
      },
      editedItem (val) {
        if (val.donativo > 0) {
          const donativo = val.donativo
          const formattedNumber = donativo.toLocaleString('es-ES', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
          val.donativo = formattedNumber
        }
      },
      // Se dispara cada vez que el formulario se abre/cierra
      async ofertasadd (val) {
        if (val) {
          // El formulario se acaba de abrir
          if (this.editedItem.id) {
            // Modo edición: cargar entrevistas desde la API
            await this.$store.dispatch('registros/getEntrevistasOferta', this.editedItem.id)
          } else {
            // Modo creación: asegurar tabla vacía
            this.$store.commit('registros/setEntrevistas', [])
          }
        }
      },
      async searchCandidata (val) {
        if (!val) return

        // Evitar buscar si coincide exactamente con la candidata seleccionada
        if (this.editedItem.candidata) {
          const selectedId = Array.isArray(this.editedItem.candidata)
            ? this.editedItem.candidata[0]
            : this.editedItem.candidata
          const selected = this.candidatasList.find(u => u.id === selectedId)
          if (selected && selected.nombre_apellido === val) {
            return
          }
        }

        this.loadingCandidata = true
        try {
          const response = await this.$store.dispatch('registros/getregistrosByName', val)
          const newItems = response.data || []
          // Combinar con la lista existente para no perder la seleccionada
          const merged = [...this.candidatasList]
          newItems.forEach(item => {
            if (!merged.some(x => x.id === item.id)) {
              merged.push(item)
            }
          })
          this.candidatasList = merged
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
        } finally {
          this.loadingCandidata = false
        }
      },
    },
    async beforeMount () {
      await this.$store.commit('ofertas/setRegister', false)
    },
    async mounted () {
      await this.$store.dispatch('registros/getregistros')

      const initialList = [...this.usuarias]

      // Asegurar que candidatas seleccionadas estén en la lista para que se muestre su nombre
      if (this.editedItem.candidata) {
        if (Array.isArray(this.editedItem.candidata)) {
          this.editedItem.candidata.forEach(item => {
            if (item && typeof item === 'object' && item.id) {
              if (!initialList.some(x => x.id === item.id)) {
                initialList.push(item)
              }
            }
          })
          const first = this.editedItem.candidata[0]
          this.editedItem.candidata = first ? (typeof first === 'object' ? first.id : first) : null
        } else if (typeof this.editedItem.candidata === 'object' && this.editedItem.candidata.id) {
          if (!initialList.some(x => x.id === this.editedItem.candidata.id)) {
            initialList.push(this.editedItem.candidata)
          }
          this.editedItem.candidata = this.editedItem.candidata.id
        }
      }

      this.candidatasList = initialList

      // Limpiar entrevistas al montar (datos = {} en ese momento, no hay id aún)
      this.$store.commit('registros/setEntrevistas', [])
    },
    methods: {
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      volver () {
        this.editedIndex = -1
        this.$refs.form.reset()
        this.$store.commit('ofertas/setRegister', false)
        this.$store.commit('registros/setEntrevistas', [])
      },
      submit () {
        if (this.$refs.form.validate()) {
          const data = {
            index: this.editedIndex,
            id: this.editedItem.id,
            fecha: this.editedItem.fecha,
            oferta: this.editedItem.oferta,
            condiciones: this.editedItem.condiciones,
            candidata: this.editedItem.candidata,
            estado: this.editedItem.estado,
            ofertante: this.editedItem.ofertante,
            donativo: this.editedItem.donativo,
            observaciones: this.editedItem.observaciones,
          }

          if (this.editedIndex < 0) {
            this.$store.dispatch('ofertas/addOfertas', data)
              .then((response) => {
                Vue.notify({
                  group: 'loggedIn',
                  text: response.data.success,
                  type: 'teal accent-3',
                  duration: 5000,
                })
              })
              .catch(err => {
                // eslint-disable-next-line
                console.log(err)
                Vue.notify({
                  group: 'loggedIn',
                  text: 'No se pudo guardar en este momento',
                  type: 'red accent-2',
                  duration: 5000,
                })
              },
              )
          } else {
            this.$store.dispatch('ofertas/updateOfertas', data)
              .then((response) => {
                Vue.notify({
                  group: 'loggedIn',
                  text: response.data.success,
                  type: 'teal accent-3',
                  duration: 5000,
                })
                if (response.data.email) {
                  setTimeout(() => {
                    this.$store.dispatch('logout')
                  }, 3000)
                }
              })
              .catch(err => {
                // eslint-disable-next-line
                console.log(err)
                Vue.notify({
                  group: 'loggedIn',
                  text: 'No se pudo guardar en este momento',
                  type: 'red accent-2',
                  duration: 5000,
                })
              },
              )
          }
        }
      },
      agregarEntrevista () {
        if (!this.editedItem.id || !this.entrevistaFecha) return

        // Nombre de candidata para mostrar en la tabla local
        const candidataObj = this.candidatasList.find(u => u.id === this.editedItem.candidata)
        const candidataNombre = candidataObj ? candidataObj.nombre_apellido : ''

        const payload = {
          oferta_id: String(this.editedItem.id),
          usuaria_id: String(this.editedItem.candidata),
          fecha: this.entrevistaFecha,
          confirmada: this.entrevistaContratada,
        }

        this.$store.dispatch('registros/addEntrevistaOferta', payload)
          .then((response) => {
            const nuevoRegistro = {
              id: response.data.id,
              usuaria_nombre: candidataNombre,
              fecha: this.entrevistaFecha,
              confirmada: this.entrevistaContratada === 1,
            }
            this.$store.commit('registros/addEntrevista', nuevoRegistro)
            // Reset campos de entrevista
            this.entrevistaFecha = ''
            this.entrevistaDatePicker = new Date().toISOString().substr(0, 10)
            this.entrevistaContratada = 0
            Vue.notify({
              group: 'loggedIn',
              text: response.data.success,
              type: 'teal accent-3',
              duration: 5000,
            })
          })
          .catch(err => {
            // eslint-disable-next-line
            console.log(err)
            Vue.notify({
              group: 'loggedIn',
              text: 'No se pudo registrar la entrevista',
              type: 'red accent-2',
              duration: 5000,
            })
          })
      },
      eliminarEntrevista (item) {
        this.$confirm('¿Está seguro que desea eliminar este registro?', {
          buttonTrueText: 'Si',
          buttonFalseText: 'No',
        }).then(res => {
          if (res) {
            this.$store.dispatch('registros/deleteEntrevistaOferta', item.id)
              .then((response) => {
                Vue.notify({
                  group: 'loggedIn',
                  text: response.data.success,
                  type: 'teal accent-3',
                  duration: 5000,
                })
              })
              .catch(err => {
                // eslint-disable-next-line
                console.log(err)
                Vue.notify({
                  group: 'loggedIn',
                  text: 'No se pudo eliminar en este momento',
                  type: 'red accent-2',
                  duration: 5000,
                })
              })
          }
        })
      },
    },
  }
</script>

<style scoped>
.v-card {
  margin-top: 0px;
  margin-bottom: 0px;
}
.v-card__title {
  background-color: aliceblue;
}
.expansionPanel {
  width: 100%;
}
.vue-tel-input {
  height: 50px;
  border: none;
  border-bottom: 1px solid #bbb;
}
</style>
